<template>


  <div class="order-add" v-show="step === 'upload'">
    <div class="header-wrapper txt-center">
      <div class="h1">{{ t('orderImport.title') }}</div>
    </div>
    <div class="download-zone download-zone-large" ref="dropzoneElement">
      <div class="progress-group-list" v-if="fileDoc">
        <div class="progress-group">
          <div class="progress-title">
            <p class="font-16">{{ fileDoc.name }} <span class="muted-14">{{ formatFileSize(fileDoc.size) }}</span></p>
            <button class="progress-cansel" @click.stop="removeFile" type="button">
              <svg class="svg-cross">
                <use href="/img/sprite.svg#svg-cross"></use>
              </svg>
            </button>
          </div>
          <div class="progress-line-group">
            <div class="progress-status">
              <svg v-if="checkCompleted && canImport" class="svg-check-fill">
                <use href="/img/sprite.svg#svg-check-fill"></use>
              </svg>
              <div v-else class="font-11">{{ fileDoc.progress }}%</div>
            </div>
            <div class="progress-line">
              <span :style="{ width: fileDoc.progress + '%' }"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="download-zone-box">
        <div class="download-icon">
          <svg class="svg-load">
            <use href="/img/sprite.svg#svg-load"></use>
          </svg>
        </div>
      </div>
      <div class="download-zone-text attachment-button" v-if="!fileDoc">
        <p>{{ t('orderImport.dropText') }}
          <a href="#!" class="txt-accent" @click.prevent="openFileDialog">{{ t('orderImport.chooseFile') }}</a>
        </p>
        <div class="download-zone-conditions">
          <span class="muted-13">{{ t('orderImport.allowedFormats') }}</span>
          <span class="muted-13">{{ t('orderImport.maxSize') }}</span>
        </div>
      </div>
    </div>

    <div class="download-zone-note font-14">
      <div class="txt-red">{{ t('orderImport.warningTitle') }}</div>
      <p>{{ t('orderImport.warningText') }}<br><a class="big_url" href="/upload/importtemplate.xlsx" target="_blank">Скачать шаблон файла</a> </p>
    </div>

    <div class="modal-wrapper font-15" v-if="serverErrors.length || checkCompleted">
      <div class="error-message" v-if="serverErrors.length">
        <div v-for="(error, index) in serverErrors" :key="index">{{ error }}</div>
      </div>
      <p v-if="checkCompleted && canImport" class="txt-center">
        {{ t('orderImport.foundRows', { count: positions.length }) }}
      </p>
    </div>

    <div class="flex-center" v-if="fileDoc && !isSubmitting">
      <button class="btn-outline" type="button" @click="removeFile">{{ t('modals.cancel') }}</button>
    </div>
  </div>

  <template v-if="step === 'preview'">
    <div class="header-wrapper header-wrapper--row">
      <div class="header-group flex-column">
        <div class="label label-orange">
          <span class="font-15">{{ t('orderPage.createOrder') }}</span>
        </div>
        <div class="h1">{{ t('orderPage.titlePreview', { number: order.number }) }}</div>
      </div>
    </div>

    <ul class="info-list">
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.supplier') }}</p>
        <p class="font-16">{{ order.partner_name || order.partner }}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.orderDate') }}</p>
        <p class="font-16">{{ order.date }}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.orderNumber') }}</p>
        <p class="font-16">{{ order.number }}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.invoisNumber') }}</p>
        <p class="font-16">{{ order.invois }}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.invoisDate') }}</p>
        <p class="font-16">{{ order.invois_date }}</p>
      </li>
    </ul>

    <Positions mode="import" :order="order" v-model:positions="positions" :orderLoaded="true" @save="save" :isParentSubmitting="isSubmitting" />

    <div class="error-message" v-if="serverErrors.length">
      <div v-for="(error, index) in serverErrors" :key="index">{{ error }}</div>
    </div>

    <div v-if="false" class="buttons-grid four-columns">
      <button class="btn-outline w-100" :class="{loader:isSubmitting === 'draft'}" type="button" @click="save(false)">
        {{ t('orderPage.saveAsDraft') }}
      </button>
      <button class="btn w-100" :class="{loader:isSubmitting === 'send'}" type="button" @click="save(true)">
        {{ t('orderPage.sendPartner') }}
      </button>
    </div>
  </template>
</template>

<script>
import axios from 'axios';
import { Dropzone } from 'dropzone';
import 'dropzone/dist/dropzone.css';
import { mapActions } from 'vuex';
import { useI18n } from 'vue-i18n';
import Positions from '@/components/order/Positions.vue';

export default {
  components: { Positions },
  data: () => ({
    step: 'upload',
    fileDoc: null,
    dropzoneInstance: null,
    isSubmitting: null,
    checkCompleted: false,
    canImport: false,
    serverErrors: [],
    order: {},
    positions: [],
  }),
  setup() {
    const { t } = useI18n();
    return { t };
  },
  mounted() {
    this.initDropzone();
  },
  beforeUnmount() {
    if (this.dropzoneInstance) {
      this.dropzoneInstance.destroy();
    }
  },
  methods: {
    ...mapActions('notify', ['addNotify']),
    ...mapActions('positions', ['syncPositionsFromOrder']),
    initDropzone() {
      this.dropzoneInstance = new Dropzone(this.$refs.dropzoneElement, {
        url: '/',
        method: 'post',
        disablePreviews: true,
        autoProcessQueue: false,
        clickable: false,
        maxFiles: 1,
        maxFilesize: 2,
        acceptedFiles: '.xls,.xlsx',
        addRemoveLinks: false,
        autoQueue: false,
      });

      this.dropzoneInstance.on('addedfile', (file) => {
        if (this.fileDoc) {
          this.dropzoneInstance.removeFile(this.fileDoc.file);
        }
        this.resetCheckState();
        this.fileDoc = { name: file.name, size: file.size, progress: 0, file };
        this.checkFile();
      });

      this.dropzoneInstance.on('error', (file, errorMessage) => {
        this.serverErrors = [String(errorMessage)];
        this.dropzoneInstance.removeFile(file);
      });
    },
    openFileDialog() {
      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = false;
      input.accept = '.xls,.xlsx';
      input.addEventListener('change', (e) => {
        const file = e.target.files[0];
        if (file) {
          this.dropzoneInstance.addFile(file);
        }
      });
      input.click();
    },
    async checkFile() {
      if (!this.fileDoc) {
        return;
      }

      this.isSubmitting = 'check';
      this.serverErrors = [];
      const formData = new FormData();
      formData.append('file', this.fileDoc.file);

      try {
        this.fileDoc.progress = 30;
        const response = await axios.post('/api/order/load/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        this.fileDoc.progress = 100;

        if (response.data.status === 'error') {
          this.serverErrors = this.extractErrors(response.data.errors);
          return;
        }

        const data = response.data.data || {};
        this.order = data.order || {};
        this.positions = Array.isArray(data.positions) ? data.positions : [];
        this.canImport = Boolean(data.can_import);
        this.checkCompleted = true;
        this.serverErrors = Array.isArray(data.errors) ? data.errors.map(error => error.message || String(error)) : [];
        this.syncPositionsFromOrder({
          positions: this.positions,
          storage_delivery: data.storage_delivery || {},
          storage_shipment: data.storage_shipment || {},
        });
        if (this.canImport && !this.serverErrors.length) {
          this.step = 'preview';
        }
      } catch (error) {
        this.serverErrors = [error?.message || String(error)];
      } finally {
        this.isSubmitting = null;
      }
    },
    async save(send) {
      this.isSubmitting = send ? 'send' : 'draft';
      this.serverErrors = [];

      try {
        const formData = new FormData();
        formData.append('order', JSON.stringify(this.order));
        formData.append('positions', JSON.stringify(this.positions));
        formData.append('send', send ? '1' : '0');

        const response = await axios.post('/api/order/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.status === 'error') {
          this.serverErrors = this.extractErrors(response.data.errors);
          return;
        }

        const orderId = response.data.data?.id;
        this.addNotify({ text: send ? this.t('orderImport.savedAndSent') : this.t('orderImport.savedDraft') });
        if (orderId) {
          this.$router.push({ name: 'order', params: { id: orderId } });
        }
      } catch (error) {
        this.serverErrors = [error?.message || String(error)];
      } finally {
        this.isSubmitting = null;
      }
    },
    removeFile() {
      if (this.fileDoc?.file && this.dropzoneInstance) {
        this.dropzoneInstance.removeFile(this.fileDoc.file);
      }
      this.fileDoc = null;
      this.resetCheckState();
    },
    resetCheckState() {
      this.isSubmitting = null;
      this.checkCompleted = false;
      this.canImport = false;
      this.serverErrors = [];
      this.order = {};
      this.positions = [];
      this.step = 'upload';
    },
    extractErrors(errors) {
      if (!Array.isArray(errors) || !errors.length) {
        return [this.t('errors.serverError')];
      }
      return errors.map(error => error.message || String(error));
    },
    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' Kb';
      return Math.round(bytes / (1024 * 1024)) + ' Mb';
    },
  },
};
</script>
